import { gql } from "@apollo/client";
import {TypeDefinitionAttributeFields} from "../fragments/typeDefinitionAttribute";

export const SearchAssetTdas = gql`
    query SearchAssetTdas ($typeDefinitionIndex: SearchFilterAttributeTypeDefinitionIndex) {
        searchAssets {
            filterTypeDefinitionAttributeList (typeDefinitionIndex: $typeDefinitionIndex) {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;


